'use client';

import { useEffect, useState } from 'react';
import {
  registerServiceWorker,
  type ServiceWorkerRegisterResult,
} from '@/lib/platform/serviceWorker';

/**
 * Registra o service worker uma vez, no shell privado.
 *
 * Devolve o resultado para que a falha seja **estado observável** e não um
 * `catch` vazio (A4): hoje ninguém renderiza esse estado, mas o `console.warn`
 * é o que dá o que olhar na bancada em device — que é o único lugar onde o
 * caminho real acontece.
 */
export function useServiceWorkerRegistration(): ServiceWorkerRegisterResult | null {
  const [resultado, setResultado] = useState<ServiceWorkerRegisterResult | null>(null);

  useEffect(() => {
    let vivo = true;
    void registerServiceWorker().then((r) => {
      if (!vivo) return;
      setResultado(r);
      if (r.outcome === 'failed') {
        console.warn('[sw] registro falhou:', r.error);
      }
    });
    return () => {
      vivo = false;
    };
  }, []);

  return resultado;
}
